export default __webpack_public_path__ + "static/icons-5bb33473de366bc1fcf050a9a07f101f.svg";